export * from '@sportworld/js-sdk/src/constants/settings'

export const settingsTitles = {
  DATA_PRIVACY: 'SETTINGS_DATA_PRIVACY',
  IMPRINT: 'SETTINGS_IMPRINT',
  TERMS_CONDITIONS: 'SETTINGS_TERMS_CONDITIONS',
}

export const accountLayoutData = {
  title: 'accountTitle',
  description: 'accountDescription',
}

export const consentLayoutData = {
  title: 'SETTINGS_COOKIE_BANNER',
  subtitle: 'consentTitle',
  description: 'consentDescription',
}
